<template>
  <object-fit-wrapper class="canvas-scrolly" :aspectRatio="aspectRatio">
    <template >
      <canvas ref="canvas"></canvas>
      <!-- <iframe class="map-ai2html-overlay" v-if="ai2htmlsrc" :src="ai2htmlsrc" frameborder="0" scrolling="no" ></iframe> -->
    </template>
  </object-fit-wrapper>
</template>

<script>
import ObjectFitWrapper from './../ObjectFitWrapper.vue'
import debounce from 'lodash/debounce'

export default {
  props: ['src', 'progress', 'range', 'ai2htmlsrc'],
  components: {ObjectFitWrapper},
  data () {
    return {
      images: {},
      ctx: null,
      debugMsg: '',
      aspectRatio: 1,
      currentImgIndex: 0
    }
  },
  watch: {
    progress (newVal, oldVal) {
      this.currentImgIndex = this.getImageIndex(oldVal)
      const imgIndex = this.getImageIndex(newVal)

      if (this.currentImgIndex !== imgIndex) {
        requestAnimationFrame(() => {
          this.drawImage(imgIndex)
        })
      }
    },
    aspectRatio (newVal) {
      this.$emit('changeaspectratio', newVal)
    }
  },
  // computed: {
  //   iframeDims (){
  //     return { width: `${this.$window.innerWidth}px !important`, height: `${this.$window.innerHeight}px !important` }
  //   }
  // },
  mounted () {
    const _this = this
    // this.$loading.startLoading()
    this.ctx = this.$refs.canvas.getContext('2d')

    // 1. first load 50 frame of images close to current scroll progress
    const amount = 50
    const [min, max] = this.range
    let middle = this.getImageIndex(this.progress)
    let from = this.clamp(middle - amount / 2, min, max)
    let to = this.clamp(middle + amount / 2, min, max)

    for (var i = from; i <= to; i++) {
      this.loadImage(i, (image, ind) => {
        if (ind < from + 5) {
          image.onload = () => this.aspectRatio = image.naturalHeight / image.naturalWidth
        }
        // this.$loading.endLoading()
        // const img = this.images[middle]
        // if (img) {
        //   this.drawImage(middle)
        //   this.$emit('canplaythrough')
        // }
      })
    }

    // 2. load remaining frame images
    for (var j = from - 1; j >= min; j--) {
      this.loadImage(j)
    }
    for (var k = to + 1; k <= max; k++) {
      this.loadImage(k)
    }

    this.checkThenDraw(middle)

    window.addEventListener('resize', debounce(function () {
      _this.checkThenDraw(_this.getImageIndex(_this.progress))
    }, 150, {'leading':false}))

  },
  methods: {
    checkThenDraw (index) {
      const img = this.images[index]
      const {canvas} = this.$refs

      if (!this.ctx || !img || !canvas) {
        setTimeout(() => {
          this.checkThenDraw(index)
        }, 500)
        return
      }
      this.drawImage(index)
      this.$emit('canplaythrough')
    },
    loadImage (i, cb) {
      fetch(this.getImageStr(i))
        .then(res => res.blob())
        .then(blob => {
          this.images[i] = new Image()
          this.images[i].setAttribute('src', URL.createObjectURL(blob))
          if (cb) cb(this.images[i], i)
        })
    },
    drawImage (index) {
      const img = this.images[index]
      if (!img) return
      const {canvas} = this.$refs
      const canvasHeight = this.isMobile() ? 800 : this.isTabletWidth() ? canvas.height : canvas.width / 1.75

      this.ctx.drawImage(img, 0, 0, canvas.width, canvasHeight)
      // this.ctx.drawImage(img, 0, 0, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height)
    },
    getImageStr (index) {
      const imgIndexString = `0000`.replace(new RegExp(`0{${index.toString().length}}\\b`, 'g'), index)
      return require(`videos/${this.src}${this.isMobile() ? '' : '-desktop'}/${imgIndexString}.jpg`)
    },
    getImageIndex (progress) {
      const [min, max] = this.range
      return Math.round((max - min) * progress) + min
    },
    clamp (value, min, max) {
      return Math.min(Math.max(value, min), max)
    },
    isMobile () {
      return (/Android|iPhone|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera) // separated iPad, within isTabletWidth scope
    },
    isTabletWidth () {
      return (/Android|iPad/i).test(navigator.userAgent || navigator.vendor || window.opera) && this.$window.innerWidth <= 768
    },
  }
}
</script>

<style lang="scss">
.canvas-scrolly {
  canvas, iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background-color: yellow;
  }
}
</style>
